export default __webpack_public_path__ + "static/media/territory_management.c6363e03.png";